import { UiTourType } from '@booking-booster-client/models';
import { settingsAccounting } from './steps';

export const SettingsAccountingTour: UiTourType = {
  slug: 'settings-accounting',
  steps: settingsAccounting,
  viewingRequired: true,
};
